<template>
   <div class="pagination_right" v-if="total > 0">
        <el-pagination
          v-if="!$store.getters.tagsView"
          small
          background
          :layout="layout"
          :total="total"
          :page-size="listQuery.pageSize"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
           :current-page.sync="listQuery.page"
           :page-sizes="pageOptions.options"
        ></el-pagination>
        <el-col :span="24" v-if="$store.getters.tagsView">
          <el-pagination
            background
            :layout="layout"
            :total="total"
            :page-size="listQuery.pageSize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.page"
            :page-sizes="pageOptions.options"
          ></el-pagination>
        </el-col>
      </div>
</template>

<script>
import { pageOptions } from '@/utils/config.js'
export default {
  name: 'TableRelatedPagination',
  props: {
    listQuery: {
      type: Object,
      default: () => {
        return {}
      }
    },
    total: { // 总数
      type: Number,
      default: 0
    },
    layout: { // 默认显示
      type: String,
      // default: 'prev, pager, next,sizes,total' // 显示所有的数据
      default: 'prev, pager, next'
    }
  },
  data () {
    return {
      pageOptions
    }
  },
  methods: {
    //   每页条数
    handleSizeChange (val) {
      this.$emit('size-change', val)
    },
    // 当前页数
    handleCurrentChange (val) {
      this.$emit('current-change', val)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
